








import Vue, { PropType } from 'vue'
import { TreeviewUser } from '@/api/Auth/auth.interface'
import UserTreeview from './UserTreeview.vue'
import Dialog from '@/components/Dialog.vue'

export default Vue.extend({
  components: {
    appUserTreeview: UserTreeview,
    appDialog: Dialog,
  },
  props: {
    item: Object as PropType<TreeviewUser>,
  },
})
